/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint no-param-reassign: ["error", { "props": false }] */
import Vue from 'vue';
import * as mTypes from '../../mutation-types';

const state = {
  permits: [],
  error: null,
};

const getters = {
  permits: state => state.permits,
  error: state => state.error,
};

const actions = {
  fetch({ commit }, payload) {
    const path = `${payload.user.data.selectedRole.role}s/${payload.user.data.selectedRole.id}`;
    // TODO: has to be limit for now
    return Vue.http.get(`${process.env.BACKEND_API_URL}api/${path}/permits?userId=${payload.id}&limit=100`).then((response) => {
      const tableData = [];
      response.data.items.forEach((permit) => {
        tableData.push({
          parkingCardNr: permit.parkingCardNr,
          vehicleReg: permit.vehicle ? permit.vehicle.vehicleReg : null,
          productName: permit.product ? permit.product.name : null,
          productId: permit.product ? permit.product.id : null,
          tenantId: permit.partner ? permit.partner.id : null,
          partnerName: permit.partner ? permit.partner.name : null,
          id: permit.id,
          zones: permit.product ? permit.product.zones.map(z => z.code).join(', ') : null,
        });
      });
      commit(mTypes.DATA_FETCHED, tableData);
    });
  },
};

const mutations = {
  [mTypes.DATA_FETCHED](state, permits) {
    state.permits = permits;
  },
  [mTypes.CLEAR_STATE](state) {
    state.permits = [];
  },
  [mTypes.DATA_ERROR](state, error) {
    state.error = error;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/users/permits.js